import React from 'react';
import { GroupPanel } from '@utex/ui-kit/desktop';
import { Button, IconSvg, Box, Typography, Colors } from '@utex/ui-kit';
import { Container } from './styles';
import { useTranslation } from 'react-i18next';

export const AppButtons: React.FC = () => {
  const { t } = useTranslation('sideMenu');

  return (
    <Container>
      <GroupPanel>
        <Button
          href={t('sideMenu:IOS app link')}
          target="_blank"
          rel="noopener noreferrer"
          view="extra-dim"
        >
          <Box marginRight={5}>
            <IconSvg src="apple" color={Colors.text.defaultDim} />
          </Box>
          <Typography.Text size="S">App&nbsp;Store</Typography.Text>
        </Button>
        <Button
          href={t('sideMenu:Google Play app link')}
          target="_blank"
          rel="noopener noreferrer"
          view="extra-dim"
        >
          <Box marginRight={5}>
            <IconSvg src="google-play" color={Colors.text.defaultDim} />
          </Box>
          <Typography.Text size="S">Google&nbsp;Play</Typography.Text>
        </Button>
      </GroupPanel>
    </Container>
  );
};
